import "./AlertBox.scss";
import React from "react";
import uniq from 'lodash/uniq';
import compact from 'lodash/compact';
import { IonAlert } from "@ionic/react";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;

  header?: string;
  buttons?: any;
  message?: string;
  className?: string;
  subHeader?: string;
  backdropDismiss?: boolean;
}

const AlertBox = ({
  isOpen,
  setIsOpen,
  className = '',
  ...props
}: Props) => {
  const classNames: string = uniq(compact(['custom-ion-alert', className])).join(' ');

  const onDidDismissHandler = () => {
    try {
      setIsOpen(false);
    } catch (e) { }
  };

  return (
    <React.Fragment>
      <IonAlert
        {...props}
        isOpen={isOpen}
        cssClass={classNames}
        onDidDismiss={onDidDismissHandler}
      />
    </React.Fragment>
  );
};

export default AlertBox;
